import {
  FaMoon,
  FaSun,
  FaExpand,
  FaCompress,
  FaRegCalendarAlt,
  FaCog,
} from "react-icons/fa";
import { FaBarsStaggered } from "react-icons/fa6";
import { useState, useEffect } from "react";
import { IoIosSearch } from "react-icons/io";
import CalendarComponent from "./CalendarComponent";
import Breadcrumb from "../Breadcrumbs/Breadcrumb";
import Button from "../../common/Button";
import { AiOutlineLogout } from "react-icons/ai";
import { useNavigate } from "react-router-dom";

const Header = ({ sidebarOpen, setSidebarOpen }) => {
  const [darkMode, setDarkMode] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!sidebarOpen || keyCode !== 27) return;
      setSidebarOpen(false);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  });

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [darkMode]);

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        alert("Error attempting to enable full-screen mode:", err);
      });
    } else {
      document.exitFullscreen();
    }
  };

  const handleLogout = () => {
    // Cookies.remove("token", { path: "/" });
    sessionStorage.clear();
    navigate("/login");
  };

  return (
    <>
      {/* Background Shape */}
      <div className="top-0 left-0 w-full bg-primary dark:bg-gray-200 text-black dark:text-gray-800">
        <div className="absolute top-0 left-0 w-full h-[500px] bg-primary dark:bg-gray-200 rounded-bl-[300px] rounded-br-[200px] z-0" />
        {/* Header */}
        <header className="bg-primary dark:bg-gray-200 text-black dark:text-gray-800 absolute top-0 left-0 right-0 z-20 px-2 lg:px-10 transition-colors duration-300">
          <div className="flex items-center justify-between py-2 gap-2 w-full flex-wrap">
            {/* Left Controls */}
            <div className="flex items-center gap-2">
              <Button
                icon={FaBarsStaggered}
                iconColor="text-white dark:text-white"
                onClick={(e) => {
                  e.stopPropagation();
                  setSidebarOpen((prev) => !prev);
                }}
                className="lg:hidden p-2 bg-white/10 dark:bg-gray-500 hover:bg-white/20 dark:hover:bg-gray-300 rounded"
              ></Button>

              {/* Fullscreen & Search */}
              <div className="relative flex items-center gap-2">
                <button
                  onClick={toggleFullscreen}
                  className="p-2 bg-white/10 dark:bg-gray-500 hover:bg-white/20 dark:hover:bg-gray-300 rounded"
                >
                  {isFullscreen ? (
                    <FaCompress className="text-white dark:text-white" />
                  ) : (
                    <FaExpand className="text-white dark:text-white" />
                  )}
                </button>
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Search..."
                    className="pl-10 pr-4 py-1.5 w-48 sm:w-64 md:w-72 bg-white/10 dark:bg-gray-100 placeholder-white/70 dark:placeholder-gray-500 text-white dark:text-gray-800 text-sm rounded-md focus:outline-none transition"
                  />
                  <IoIosSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-white dark:text-gray-600 w-5 h-5 pointer-events-none" />
                </div>
              </div>
            </div>

            {/* Right Controls */}
            <div className="flex items-center gap-2 mt-2 sm:mt-0">
              <button
                onClick={() => setDarkMode(!darkMode)}
                className="p-2 bg-white/10 dark:bg-gray-500 hover:bg-white/20 dark:hover:bg-gray-300 rounded"
              >
                {darkMode ? (
                  <FaSun className="text-yellow-400" />
                ) : (
                  <FaMoon className="text-white" />
                )}
              </button>
              <Button
                icon={FaRegCalendarAlt}
                iconColor="text-white dark:text-white"
                iconSize="w-5 h-5 "
                onClick={() => setShowCalendar(!showCalendar)}
                className="p-2 rounded-md bg-white/10 dark:bg-gray-500 hover:bg-white/20 dark:hover:bg-gray-300 transition"
              ></Button>
              {/* Calendar Dropdown */}
              {showCalendar && (
                <div className="absolute right-2 top-20 w-[90vw] max-w-md max-h-[80vh] overflow-y-auto bg-white text-primary rounded-lg shadow-xl z-50">
                  <CalendarComponent />
                </div>
              )}
              <Button
                icon={FaCog}
                iconColor="text-white dark:text-white"
                className="p-2 bg-white/10 dark:bg-gray-500 hover:bg-white/20 dark:hover:bg-gray-300 rounded"
              ></Button>
              <Button
                icon={AiOutlineLogout}
                iconColor="text-white dark:text-white"
                className="p-2 bg-white/10 dark:bg-gray-500 hover:bg-white/20 dark:hover:bg-gray-300 rounded"
                onClick={handleLogout}
              ></Button>
            </div>
          </div>

          {/* Breadcrumb */}
          <div className="mt-1 text-white">
            <Breadcrumb />
          </div>
        </header>
      </div>
    </>
  );
};

export default Header;
